import axios from "axios"
import config from "../config"
import Vue from "vue";
const moduleStore = {
    state: {
        userList: [],
    },
    mutations: {
    },
    actions: {
        async saveSystemTheme(context, data) {
            return new Promise(async (resolve, reject) => {
                try {
                    let result = await axios.post(`${config.domain}/saveSystemTheme`, data)

                    if (!result.data.errorCode || result.data.errorCode === 0) {
                        resolve(result)
                    } else {
                        context.commit("setwarning", {
                            string: result.data.errorMessage,
                            boolean: true,
                            button: [{
                                name: "Cancel",
                                callBack: function () { }
                            }]
                        })
                        resolve(false)
                    }
                }
                catch (err) {
                    reject(err)
                }
            })
        },
        async getSystemTheme(context, data) {
            return new Promise(async (resolve, reject) => {
                try {
                    let result = await axios.post(`${config.domain}/getSystemTheme`, data)

                    if (result.data.errorCode === 0) {
                        resolve(result)
                    } else {
                        context.commit("setwarning", {
                            string: result.data.errorMessage,
                            boolean: true,
                            button: [{
                                name: "Cancel",
                                callBack: function () { }
                            }]
                        })
                        resolve(false)
                    }
                }
                catch (err) {
                    reject(err)
                }
            })
        },
    },
    getters: {
    }
}

export default moduleStore;